export const paymentData = [
  {
    id: 1,
    name: 'Testimaksu 1',
    customer: {
      firstName: 'Erkki',
      lastName: 'Perämerkki',
      email: 'erkki.peramerkki@eduix.fi'
    },
    data: {
      paidAt: '2023-06-01',
      stamp: 'asda-sd1213-2242ba-sfgs',
      provider: 'Nordea',
      filingCode: 'ndea-123456-7890'
    },
    payment: {
      amount: 10000,
      currency: 'EUR',
      items: [
        {
          productCode: 'ASD123',
          description: 'Kuvaava kuvaus',
          unitPrice: 10000,
          currency: 'EUR',
          vatPercentage: 24
        }
      ]
    }
  },
  {
    id: 2,
    name: 'Testimaksu 2',
    customer: {
      firstName: 'Aino',
      lastName: 'Noitavaino',
      email: 'aino.noitavaino.@eduix.fi'
    },
    data: {
      paidAt: '2023-06-01',
      stamp: 'asda-sd1213-2242ba-sfgs',
      provider: 'Nordea',
      filingCode: 'ndea-123456-7890'
    },
    payment: {
      amount: 10000,
      currency: 'EUR',
      items: [
        {
          productCode: 'ASD123',
          description: 'Kuvaava kuvaus',
          unitPrice: 10000,
          currency: 'EUR',
          vatPercentage: 24
        }
      ]
    }
  },
  {
    id: 3,
    name: 'Testimaksu 3',
    customer: {
      firstName: 'Esko',
      lastName: 'Epäkesko',
      email: 'esko.epakesko@eduix.fi'
    },
    data: {
      paidAt: '2023-06-04',
      stamp: 'asda-sd1213-2242ba-sfgs',
      provider: 'Nordea',
      filingCode: 'ndea-123456-7890'
    },
    payment: {
      amount: 10000,
      currency: 'EUR',
      items: [
        {
          productCode: 'ASD123',
          description: 'Kuvaava kuvaus',
          unitPrice: 10000,
          currency: 'EUR',
          vatPercentage: 24
        }
      ]
    }
  }
];
